/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Filename_LabelInputs */



/**
* | output |
* | --- |
* | "Output filename" |
*
* @param {Audio_Embed_Export_Output_Filename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_filename_label = /** @type {((inputs?: Audio_Embed_Export_Output_Filename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Filename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("nom du fichier de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabedateiname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del file di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя выходного файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("nombre del archivo de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出文件名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力ファイル名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट फ़ाइल नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do arquivo de saída")
	return /** @type {LocalizedString} */ ("Output filename")
});